import * as React from "react";
const BioTerrorismSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#040919"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#040919"
      strokeOpacity={0.03}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#040919"
      d="M41.084 19.237a.875.875 0 0 0-.822-.822c-5.662-.328-10.207 1.393-12.16 4.617-1.291 2.132-1.29 4.721-.018 7.19a7.803 7.803 0 0 0-1.55 2.954l-1.78-1.786c.856-1.786.823-3.648-.109-5.194-1.444-2.384-4.776-3.661-8.914-3.418a.876.876 0 0 0-.823.822c-.243 4.138 1.035 7.47 3.418 8.914.787.48 1.69.735 2.612.735a5.969 5.969 0 0 0 2.577-.62l2.735 2.734V38.5a.875.875 0 1 0 1.75 0v-3.225a6.082 6.082 0 0 1 1.342-3.828 8.084 8.084 0 0 0 3.643.918 6.661 6.661 0 0 0 3.481-.969c3.225-1.95 4.95-6.497 4.618-12.158ZM19.23 31.018c-1.678-1.016-2.627-3.421-2.604-6.519 3.097-.026 5.502.927 6.518 2.604.53.875.617 1.896.27 2.947l-2.67-2.67a.875.875 0 0 0-1.237 1.237l2.67 2.67c-1.052.348-2.071.261-2.947-.269Zm16.33-1.118c-1.465.887-3.188.955-4.938.219l5.873-5.873a.875.875 0 0 0-1.237-1.238l-5.874 5.866c-.74-1.75-.672-3.473.219-4.938 1.525-2.516 5.14-3.918 9.77-3.81.105 4.63-1.295 8.25-3.813 9.774Z"
    />
  </svg>
);
export default BioTerrorismSVG;
